import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next'; // Import hook for translations

const HomePage = () => {
  const [activeCategory, setActiveCategory] = useState(null);
  const { t } = useTranslation(); // Get translation function

  const categories = [
    {
      key: 'Fiat',
      title: t('fiat_slovenia'),
      description: t('fiat_description'),
	  image: require('./images/fiat.jpg'),
      items: [
        { name: t('EUR-BTC'), link: '/eur-btc' },
        { name: t('zlato'), link: '/zlato-btc' },
        { name: t('srebro'), link: '/srebro-btc' },
        { name: t('neto_place'), link: '/neto-place' },
        { name: t('prag_tveganja_revscine'), link: '/prag-tveganja-revscine' },
        { name: t('bruto_domaci_proizvod'), link: '/bruto-domaci-proizvod' },
        { name: t('javni_dolg'), link: '/javni-dolg' }
      ]
    },
    {
      key: 'real-estate',
      title: t('real_estate'),
      description: t('real_estate_description'),
	  image: require('./images/nepremicnine.jpg'),
      items: [
        { name: t('nova_stanovanja'), link: '/nepremicnine/nova-stanovanja-slovenija' },
        { name: t('rabljena_stanovanja'), link: '/nepremicnine/rabljena-stanovanja-slovenija' },
        { name: t('rabljena_stanovanja_ljubljana'), link: '/nepremicnine/rabljena-stanovanja-ljubljana' },
        { name: t('rabljena_stanovanja_maribor'), link: '/nepremicnine/rabljena-stanovanja-maribor' },
        { name: t('hise'), link: '/nepremicnine/hise' }
      ]
    },
    {
      key: 'food-drinks',
      title: t('food_drinks'),
      description: t('food_drinks_description'),
	  image: require('./images/hrana-pijaca.jpg'),
      items: [
        { name: t('riz'), link: '/hrana-pijaca/riz-beli' },
        { name: t('kruh'), link: '/hrana-pijaca/kruh' },
        { name: t('testenine'), link: '/hrana-pijaca/testenine' },
        { name: t('meso'), link: '/hrana-pijaca/meso' },
        { name: t('mleko'), link: '/hrana-pijaca/mleko' },
        { name: t('jajca'), link: '/hrana-pijaca/jajca' },
        { name: t('maslo'), link: '/hrana-pijaca/maslo' },
        { name: t('jabolka'), link: '/hrana-pijaca/jabolka' },
        { name: t('banane'), link: '/hrana-pijaca/banane' },
        { name: t('paradiznik'), link: '/hrana-pijaca/paradiznik' },
        { name: t('cebula'), link: '/hrana-pijaca/cebula' },
        { name: t('krompir'), link: '/hrana-pijaca/krompir' },
        { name: t('sladkor'), link: '/hrana-pijaca/sladkor' },
        { name: t('kis'), link: '/hrana-pijaca/kis' },
        { name: t('sol'), link: '/hrana-pijaca/sol' },
        { name: t('kava'), link: '/hrana-pijaca/kava' },
        { name: t('zganje'), link: '/hrana-pijaca/zganje' }
      ]
    },
    {
      key: 'medicines',
      title: t('medicines'),
      description: t('medicines_description'),
	  image: require('./images/zdravila.jpg'),
      items: [
        { name: t('aspirin'), link: '/zdravila/aspirin' },
        { name: t('rupurut'), link: '/zdravila/rupurut' },
        { name: t('sirup_kaselj'), link: '/zdravila/sirup-kaselj' },
        { name: t('vitamin_c'), link: '/zdravila/vitamin-c' }
      ]
    },
    {
      key: 'products',
      title: t('products'),
      description: t('products_description'),
	  image: require('./images/izdelki.jpg'),
      items: [
        { name: t('moska_obleka'), link: '/izdelki/moska-obleka' },
        { name: t('moska_srajca'), link: '/izdelki/moska-srajca' },
        { name: t('zenska_bluza'), link: '/izdelki/zenska-bluza' },
        { name: t('otroska_majica'), link: '/izdelki/otroska-majica' },
        { name: t('otroske_plenice'), link: '/izdelki/otroske-plenice' },
        { name: t('pralni_stroj'), link: '/izdelki/pralni-stroj' },
        { name: t('likalnik'), link: '/izdelki/likalnik' },
        { name: t('pribor'), link: '/izdelki/pribor' },
        { name: t('ponev'), link: '/izdelki/ponev' },
        { name: t('kosilnica'), link: '/izdelki/kosilnica' },
        { name: t('pralni_prasek'), link: '/izdelki/pralni-prasek' },
        { name: t('tekoci_detergent'), link: '/izdelki/tekoci-detergent' },
        { name: t('renault_clio'), link: '/izdelki/renault-clio' },
        { name: t('vw_polo'), link: '/izdelki/vw-polo' },
        { name: t('kolo'), link: '/izdelki/kolo' },
        { name: t('casopis'), link: '/izdelki/casopis' },
        { name: t('solski_zvezek'), link: '/izdelki/solski-zvezek' },
        { name: t('svincnik'), link: '/izdelki/svincnik' }
      ]
    },
    {
      key: 'energy',
      title: t('energy'),
      description: t('energy_description'),
	  image: require('./images/energija.jpg'),
      items: [
        { name: t('diesel_gorivo'), link: '/energija/diesel-gorivo' },
        { name: t('bencin'), link: '/energija/bencin' },
        { name: t('elektrika'), link: '/energija/elektrika' },
        { name: t('zemeljski_plin'), link: '/energija/zemeljski-plin' },
        { name: t('kurilno_olje'), link: '/energija/kurilno-olje' }
      ]
    },
    {
      key: 'services',
      title: t('services'),
      description: t('services_description'),
	  image: require('./images/storitve.jpg'),
      items: [
        { name: t('tehnicni_pregled'), link: '/storitev/tehnicni-pregled' },
        { name: t('mestni_avtobus'), link: '/storitev/mestni-avtobus' },
        { name: t('prevoz_taksi'), link: '/storitev/prevoz-taksi' },
        { name: t('postnina'), link: '/storitev/postnina' },
        { name: t('fitnes'), link: '/storitev/fitnes' },
        { name: t('kino'), link: '/storitev/kino' },
        { name: t('gledalisce'), link: '/storitev/gledalisce' },
        { name: t('nocitev_hotel'), link: '/storitev/nocitev-hotel' },
        { name: t('mosko_strizenje'), link: '/storitev/mosko-strizenje' },
        { name: t('zensko_strizenje'), link: '/storitev/zensko-strizenje' },
        { name: t('pogreb'), link: '/storitev/pogreb' }
      ]
    },
    {
      key: 'restaurant',
      title: t('restaurant'),
      description: t('restaurant_description'),
	  image: require('./images/restavracija.jpg'),
      items: [
        { name: t('testenine_z_omako'), link: '/restavracija/testenine-omaka' },
        { name: t('meni_kosilo'), link: '/restavracija/meni-kosilo' },
        { name: t('pica'), link: '/restavracija/pica' },
        { name: t('palacinke'), link: '/restavracija/palacinke' },
        { name: t('coca_cola'), link: '/restavracija/coca-cola' },
        { name: t('espresso'), link: '/restavracija/espresso' }
      ]
    }
  ];

  const toggleCategory = (key) => {
    setActiveCategory(activeCategory === key ? null : key);
  };

  return (
    <div className="homepage-container">
      <div className="category-grid">
        {categories.map((category) => (
          <div
            key={category.key}
            className={`category-card ${activeCategory === category.key ? 'active' : ''}`}
            onClick={() => toggleCategory(category.key)}
          >
            <img src={category.image} alt={category.title} />
            <h2>{category.title}</h2>
            <p>{category.description}</p>
            {activeCategory === category.key && (
              <div className="category-items">
  <div className="column">
    {category.items
      .filter((_, index) => index % 2 === 0) // Left column: Even-indexed items
      .map((item) => (
        <Link key={item.link} to={item.link}>
          {item.name}
        </Link>
      ))}
  </div>
  <div className="column">
    {category.items
      .filter((_, index) => index % 2 !== 0) // Right column: Odd-indexed items
      .map((item) => (
        <Link key={item.link} to={item.link}>
          {item.name}
        </Link>
      ))}
  </div>
</div>
            )}
          </div>
        ))}
      </div>
	  <hr></hr>
	  <img src={`${process.env.PUBLIC_URL}/Logo1.svg`} alt="Logo" width="300"/>
	  <p>{t('bitcoinsi')}</p>
	  <hr></hr>
	  <h2>{t('why_measure_in_bitcoin')}</h2>
	  <p>{t('bitcoin_description')}</p>
	  <p>{t('bitcoin_impact')}</p>
	  <hr></hr>
	  <h2>{t('home_nodes')}</h2>
	  <a href="https://bitcoin.si/">
			<img className="home-nodes special-image" src={`${process.env.PUBLIC_URL}/Bitcoin_drustvo_Slovenije.png`} />
	  </a>
      <a href="https://europeanbitcoiners.com/">
			<img className="home-nodes special-image" src={`${process.env.PUBLIC_URL}/EU_Bitcoiners.png`} />
      </a>
    </div>
  );
};

export default HomePage;
